import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "primereact/button";
import DashboardLayout from "../../../layouts/DashboardLayout";
import localeText from "../../../../../locale";
import { EXTRAPAY_PATH, EXTRAPAY_RATE_ANCHOR } from "./constants";
import ExtrapayBreadcrumb from "./components/ExtrapayBreadcrumb";
import ExtrapayPageHeader from "./components/ExtrapayPageHeader";
import "./ExtrapayKnowPage.css";
import { Card } from "primereact/card";

const CYCLE_CHECKS = Array.from({ length: 10 }, (_, index) => index);

const FaqItem = ({ id, title, open, onToggle, children }) => (
  <div id={id} className={`extrapay-know-faq-item${open ? " is-open" : ""}`}>
    <button type="button" className="extrapay-know-faq-trigger" onClick={onToggle}>
      <i className={`pi ${open ? "pi-chevron-down" : "pi-chevron-right"} text-xs`} />
      {title}
    </button>
    {open && <div className="extrapay-know-faq-body">{children}</div>}
  </div>
);

const ExtrapayKnowPage = () => {
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    if (window.location.hash !== `#${EXTRAPAY_RATE_ANCHOR}`) return;
    setOpenFaq("rate");
    document.getElementById(EXTRAPAY_RATE_ANCHOR)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const toggleFaq = (id) => {
    setOpenFaq((current) => (current === id ? null : id));
  };

  const headerTemplateStep1 = (
    <div
      className="border-round-top-lg p-3 flex flex-column align-items-center justify-content-center"
      style={{
        backgroundColor: "color-mix(in srgb, var(--theme-primary, #1DAF61) 10%, transparent)",
        minHeight: "13.5rem",
      }}
    >
      <div
        className="p-3 border-round-lg flex flex-column gap-3"
        style={{
          backgroundColor: "var(--theme-background, #F5F5F5)",
          border: "1px solid var(--theme-border, #E0E0E0)",
          width: "14.75rem",
        }}
      >
        <div
          className="flex align-items-center gap-2"
          style={{ color: "var(--theme-primary-dark, #145c45)" }}
        >
          <i className="pi pi-shopping-bag" />{" "}
          <span className="text-xs">{localeText("extrapayFlowStepPurchase")}</span>
        </div>
        <div>
          <span className="font-medium text-3xl extrapay-know-visual-value">€ 100</span>
        </div>
        <div className="flex align-items-center gap-2">
          <span className="text-xs" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
            {localeText("extrapayFlowStepPurchaseNote")}
          </span>
        </div>
        <hr className="m-0" style={{ border: "1px dashed var(--theme-border, #E0E0E0)" }} />
        <div className="flex align-items-center gap-2">
          <svg
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.72239 2.22834C8.75631 2.04674 8.85267 1.88271 8.9948 1.76468C9.13692 1.64664 9.31585 1.58203 9.50059 1.58203C9.68534 1.58203 9.86427 1.64664 10.0064 1.76468C10.1485 1.88271 10.2449 2.04674 10.2788 2.22834L11.1108 6.62843C11.1699 6.94125 11.322 7.229 11.5471 7.45411C11.7722 7.67923 12.0599 7.83125 12.3728 7.89034L16.7728 8.72239C16.9544 8.75631 17.1185 8.85267 17.2365 8.9948C17.3545 9.13692 17.4192 9.31585 17.4192 9.50059C17.4192 9.68534 17.3545 9.86427 17.2365 10.0064C17.1185 10.1485 16.9544 10.2449 16.7728 10.2788L12.3728 11.1108C12.0599 11.1699 11.7722 11.322 11.5471 11.5471C11.322 11.7722 11.1699 12.0599 11.1108 12.3728L10.2788 16.7728C10.2449 16.9544 10.1485 17.1185 10.0064 17.2365C9.86427 17.3545 9.68534 17.4192 9.50059 17.4192C9.31585 17.4192 9.13692 17.3545 8.9948 17.2365C8.85267 17.1185 8.75631 16.9544 8.72239 16.7728L7.89034 12.3728C7.83125 12.0599 7.67923 11.7722 7.45411 11.5471C7.229 11.322 6.94125 11.1699 6.62843 11.1108L2.22834 10.2788C2.04674 10.2449 1.88271 10.1485 1.76468 10.0064C1.64664 9.86427 1.58203 9.68534 1.58203 9.50059C1.58203 9.31585 1.64664 9.13692 1.76468 8.9948C1.88271 8.85267 2.04674 8.75631 2.22834 8.72239L6.62843 7.89034C6.94125 7.83125 7.229 7.67923 7.45411 7.45411C7.67923 7.229 7.83125 6.94125 7.89034 6.62843L8.72239 2.22834Z"
              stroke="var(--theme-primary, #1DAF61)"
              stroke-width="1.34583"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.832 1.58203V4.7487"
              stroke="var(--theme-primary, #1DAF61)"
              stroke-width="1.34583"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.4167 3.16797H14.25"
              stroke="var(--theme-primary, #1DAF61)"
              stroke-width="1.34583"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M3.16536 17.4167C4.03982 17.4167 4.7487 16.7078 4.7487 15.8333C4.7487 14.9589 4.03982 14.25 3.16536 14.25C2.29091 14.25 1.58203 14.9589 1.58203 15.8333C1.58203 16.7078 2.29091 17.4167 3.16536 17.4167Z"
              stroke="var(--theme-primary, #1DAF61)"
              stroke-width="1.34583"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span className="font-medium text-sm" style={{ color: "var(--theme-primary, #1DAF61)" }}>
            {localeText("extrapayFlowStepPurchasePoints")}
          </span>
        </div>
      </div>
    </div>
  );

  const headerTemplateStep2 = (
    <div
      className="border-round-top-lg p-3 flex flex-column align-items-center justify-content-center"
      style={{
        backgroundColor: "color-mix(in srgb, var(--theme-primary, #1DAF61) 10%, transparent)",
        minHeight: "13.5rem",
      }}
    >
      <div
        className="p-3 border-round-lg flex flex-column gap-3"
        style={{
          backgroundColor: "var(--theme-background, #F5F5F5)",
          border: "1px solid var(--theme-border, #E0E0E0)",
          width: "14.75rem",
        }}
      >
        <div className="text-xs" style={{ color: "var(--theme-primary-dark, #145c45)" }}>
          {localeText("extrapayFlowStepCycle")}
        </div>
        <div className="flex flex-wrap gap-2 justify-content-around">
          {CYCLE_CHECKS.map((index) => (
            <span key={index} className={`extrapay-know-check${index === 9 ? " is-done" : ""} p-2`}>
              <i className="pi pi-check text-sm font-bold" />
            </span>
          ))}
        </div>
        <div
          className="text-xs font-medium"
          style={{ color: "var(--theme-primary-dark, #145c45)" }}
        >
          {localeText("extrapayFlowStepCycleDone")}
        </div>
      </div>
    </div>
  );

  const headerTemplateStep3 = (
    <div
      className="border-round-top-lg p-3 flex flex-column align-items-center justify-content-center"
      style={{
        backgroundColor: "color-mix(in srgb, var(--theme-primary, #1DAF61) 10%, transparent)",
        minHeight: "13.5rem",
      }}
    >
      <div
        className="p-3 border-round-lg flex flex-column gap-3"
        style={{
          backgroundColor: "var(--theme-background, #F5F5F5)",
          border: "1px solid var(--theme-border, #E0E0E0)",
          width: "14.75rem",
        }}
      >
        <div
          className="flex align-items-center gap-2"
          style={{ color: "var(--theme-primary-dark, #145c45)" }}
        >
          <i className="pi pi-wallet" />
          <span className="text-xs">{localeText("extrapayFlowStepBalance")}</span>
        </div>
        <div className="flex justify-content-center">
          <div
            className="border-circle flex align-items-center justify-content-center"
            style={{
              backgroundColor: "color-mix(in srgb, var(--theme-primary, #1DAF61) 10%, transparent)",
              border: "1px solid var(--theme-border, #E0E0E0)",
              width: "4rem",
              height: "4rem",
            }}
          >
            <span className="font-medium text-xl extrapay-know-visual-value">EXC</span>
          </div>
        </div>
        <div
          className="flex align-items-center gap-2 justify-content-center"
          style={{ color: "var(--theme-primary, #1DAF61)" }}
        >
          <i className="pi pi-check text-sm font-bold" />
          <span className="text-xs">{localeText("extrapayFlowStepBalanceNote")}</span>
        </div>
      </div>
    </div>
  );
  return (
    <DashboardLayout>
      <div className="extrapay-know">
        <ExtrapayBreadcrumb
          items={[
            { labelKey: "financial", to: "/dashboard-financeiro" },
            { labelKey: "extrapayFlowTitle", to: EXTRAPAY_PATH },
            { labelKey: "extrapayFlowKnowTitle" },
          ]}
        />
        <ExtrapayPageHeader
          icon="pi pi-book"
          title={localeText("extrapayFlowKnowTitle")}
          subtitle={localeText("extrapayFlowKnowSubtitle")}
        />

        <div
          className="extrapay-know-kicker text-xs font-medium"
          style={{ color: "var(--theme-primary-dark, #145c45)" }}
        >
          {localeText("extrapayFlowKnowProgram")}
        </div>
        <h3 className="extrapay-know-heading font-medium">
          {localeText("extrapayFlowKnowHeading")}
        </h3>
        <p className="extrapay-know-intro">{localeText("extrapayFlowKnowIntro")}</p>

        <div className="extrapay-know-steps">
          <div className="h-full">
            <Card
              className="text-xs shadow-none border-round-lg h-full"
              style={{ border: "1px solid var(--theme-border, #E0E0E0)" }}
              subTitle={localeText("extrapayFlowStep1Label")}
              header={headerTemplateStep1}
            >
              <h4 className="extrapay-know-step-title">{localeText("extrapayFlowStep1Title")}</h4>
              <p className="extrapay-know-step-body">{localeText("extrapayFlowStep1Body")}</p>
            </Card>
          </div>

          <div className="h-full">
            <Card
              className="text-xs shadow-none border-round-lg h-full"
              style={{ border: "1px solid var(--theme-border, #E0E0E0)" }}
              subTitle={localeText("extrapayFlowStep2Label")}
              header={headerTemplateStep2}
            >
              <h4 className="extrapay-know-step-title">{localeText("extrapayFlowStep2Title")}</h4>
              <p className="extrapay-know-step-body">{localeText("extrapayFlowStep2Body")}</p>
            </Card>
          </div>

          <div className="h-full">
            <Card
              className="text-xs shadow-none border-round-lg h-full"
              style={{ border: "1px solid var(--theme-border, #E0E0E0)" }}
              subTitle={localeText("extrapayFlowStep3Label")}
              header={headerTemplateStep3}
            >
              <h4 className="extrapay-know-step-title">{localeText("extrapayFlowStep3Title")}</h4>
              <p className="extrapay-know-step-body">{localeText("extrapayFlowStep3Body")}</p>
            </Card>
          </div>
        </div>

        <div className="extrapay-know-after flex align-items-center gap-4 px-4 py-5">
          <div>
            <div
              className="border-circle flex align-items-center justify-content-center"
              style={{
                backgroundColor: "var(--theme-background, #F5F5F5)",
                border: "1px solid var(--theme-border, #E0E0E0)",
                width: "2.65rem",
                height: "2.65rem",
              }}
            >
              <i className="pi pi-sync" style={{ color: "var(--theme-primary-dark, #145c45)" }} />
            </div>
          </div>

          <div>
            <div className="extrapay-know-after-title">
              {localeText("extrapayFlowAfterConversionTitle")}
            </div>
            <p className="extrapay-know-after-body">
              {localeText("extrapayFlowAfterConversionBody")}
            </p>
          </div>
        </div>

        <div className="extrapay-know-balance mt-5">
          <div className="flex flex-column gap-3">
            <div className="extrapay-know-section-kicker text-xs font-medium">
              {localeText("extrapayFlowBalanceSection")}
            </div>
            <h3 style={{ color: "var(--theme-primary-dark, #145c45)" }}>
              {localeText("extrapayFlowWhereTitle")}
            </h3>
            <p className="extrapay-know-balance-copy">{localeText("extrapayFlowWhereBody")}</p>
          </div>
          <div
            className="border-round-lg p-4"
            style={{
              backgroundColor: "var(--theme-background, #F5F5F5)",
              border: "1px solid var(--theme-border, #E0E0E0)",
            }}
          >
            <div
              className="extrapay-know-flow"
              style={{ color: "var(--theme-primary-dark, #145c45)" }}
            >
              <div className="flex flex-column gap-2">
                <i className="pi pi-wallet" />
                <span className="font-medium text-sm">{localeText("extrapayFlowOnPlatform")}</span>
                <span className="text-xs">{localeText("extrapayFlowYourExcBalance")}</span>
              </div>
              <div className="extrapay-know-flow-arrow">
                <i className="pi pi-arrow-right" />
              </div>
              <div className="flex flex-column gap-2">
                <i className="pi pi-send" />
                <span className="font-medium text-sm">
                  {localeText("extrapayFlowOnExternalWallet")}
                </span>
                <span className="text-xs">{localeText("extrapayFlowSameExcAmount")}</span>
              </div>
            </div>
            <p className="extrapay-know-withdraw-path">{localeText("extrapayFlowWithdrawPath")}</p>
          </div>
        </div>

        <hr className="mt-5 mb-6" />

        <h3 className="extrapay-know-step-title font-medium" style={{ marginTop: "2rem" }}>
          {localeText("extrapayFlowFaqTitle")}
        </h3>
        <p className="extrapay-know-step-body" style={{ marginBottom: "1rem" }}>
          {localeText("extrapayFlowFaqSubtitle")}
        </p>

        <div className="extrapay-know-faq-list">
          <FaqItem
            id="extrapay-faq-when"
            title={localeText("extrapayFlowFaqWhen")}
            open={openFaq === "when"}
            onToggle={() => toggleFaq("when")}
          >
            <p>{localeText("extrapayFlowFaqWhenAnswer")}</p>
            <div className="extrapay-know-example">
              <div className="extrapay-know-example-label">
                {localeText("extrapayFlowFaqWhenExampleLabel")}
              </div>
              <p className="extrapay-know-example-formula">
                {localeText("extrapayFlowFaqWhenExampleFormula")}
              </p>
              <p>{localeText("extrapayFlowFaqWhenExampleNote")}</p>
            </div>
          </FaqItem>

          <FaqItem
            id={EXTRAPAY_RATE_ANCHOR}
            title={localeText("extrapayFlowFaqRate")}
            open={openFaq === "rate"}
            onToggle={() => toggleFaq("rate")}
          >
            <p>{localeText("extrapayFlowFaqRateAnswer")}</p>
            <p>{localeText("extrapayFlowFaqRateAnswer2")}</p>
            <div className="extrapay-know-example">
              <div className="extrapay-know-example-label">
                {localeText("extrapayFlowFaqRateCalcTitle")}
              </div>
              <p>{localeText("extrapayFlowFaqRateCalcLine1")}</p>
              <p>{localeText("extrapayFlowFaqRateCalcLine2")}</p>
              <p>{localeText("extrapayFlowFaqRateCalcLine3")}</p>
            </div>
          </FaqItem>

          <FaqItem
            id="extrapay-faq-wallet"
            title={localeText("extrapayFlowFaqWallet")}
            open={openFaq === "wallet"}
            onToggle={() => toggleFaq("wallet")}
          >
            <p>{localeText("extrapayFlowFaqWalletAnswer")}</p>
            <p>{localeText("extrapayFlowFaqWalletAnswer2")}</p>
          </FaqItem>
        </div>

        <div className="extrapay-know-cta">
          <div>
            <h3 className="font-medium" style={{ color: "var(--theme-primary-dark, #145c45)" }}>
              {localeText("extrapayFlowKnowCtaTitle")}
            </h3>
            <p className="text-sm" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
              {localeText("extrapayFlowKnowCtaBody")}
            </p>
          </div>
          <Link to={EXTRAPAY_PATH}>
            <Button
              label={localeText("extrapayFlowKnowCta")}
              className="border-round-md border-none text-sm font-medium"
              style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff", padding: "0.625rem 1rem" }}
            />
          </Link>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ExtrapayKnowPage;
